import { render, staticRenderFns } from "./ClientChat.vue?vue&type=template&id=54e01ebe"
import script from "./ClientChat.vue?vue&type=script&lang=js"
export * from "./ClientChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports